module.exports = __webpack_public_path__ + "static/media/6.6c7eb59f.jpeg";